import * as core from '../../../../../../../core'
import * as changeImpactFunctionalArea from '../change-impact-functional-area'

export const RESOURCE = {
  payload: {
    description: 'Data Integration',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactFunctionalArea.RESOURCE.payload.partialId,
    }),
    id: 'Data Integration',
    name: 'Data Integration',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
